import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import useGenres from "@/hooks/useGenres";

// Genre select + required AI Film sub-genre select (shown only for AI Film).
export default function GenreFields({ genre, subGenre, onChange, testPrefix }) {
  const { genres, ai_film: aiFilm, ai_subgenres: subs } = useGenres();
  const options = subGenre && !subs.includes(subGenre) ? [...subs, subGenre] : subs;
  return (
    <>
      <div>
        <Label>Genre</Label>
        <Select value={genre} onValueChange={(v) => { onChange("genre", v); if (v !== aiFilm) onChange("sub_genre", ""); }}>
          <SelectTrigger className="mt-1.5 bg-ink border-white/10 h-11" data-testid={`${testPrefix}-genre-select`}><SelectValue /></SelectTrigger>
          <SelectContent className="bg-surface border-white/10">
            {genres.map((g) => <SelectItem key={g} value={g}>{g}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {genre === aiFilm && (
        <div>
          <Label>AI Film sub-genre</Label>
          <Select value={subGenre || undefined} onValueChange={(v) => onChange("sub_genre", v)}>
            <SelectTrigger className="mt-1.5 bg-ink border-white/10 h-11" data-testid={`${testPrefix}-subgenre-select`}><SelectValue placeholder="Choose a sub-genre" /></SelectTrigger>
            <SelectContent className="bg-surface border-white/10">
              {options.map((s) => <SelectItem key={s} value={s} data-testid={`${testPrefix}-subgenre-${s}`}>{s}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      )}
    </>
  );
}
